'use strict';

exports.array = require('./array');
exports.matrix = require('./matrix');



//////////////////
// WEBPACK FOOTER
// ./~/ml-stat/index.js
// module id = 2
// module chunks = 0